import { useEffect, useState } from 'react';

export const useCountdown = () => {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown === 0) return;
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [countdown]);

  return {
    countdown,
    startCountdown: (value: number) => setCountdown(value),
    resetCountdown: () => setCountdown(0),
  };
};
